// Situation-specific SEO landing page configs
export const SITUATIONS = {
  "sell-probate-house": {
    slug: "sell-probate-house",
    situation: "Probate",
    h1: "Sell an Inherited or Probate House — Fast, Simple, For Cash",
    subh: "Skip the court headaches, the repairs, and the six-month listing. We buy probate properties nationwide, in any condition.",
    bullets: [
      "We work directly with executors, attorneys, and heirs",
      "Close on the estate's timeline — flexible, typically 30 days or sooner",
      "We cover all closing costs. Zero fees, zero commissions.",
    ],
    faq: [
      { q: "Can I sell before probate closes?", a: "In many states, yes. We regularly close deals that are contingent on probate. We can coordinate directly with your attorney." },
      { q: "What if the house is full of stuff?", a: "Leave whatever you want. We handle cleanout — no need to sort through decades of belongings." },
    ],
  },
  "stop-foreclosure": {
    slug: "stop-foreclosure",
    situation: "Pre-Foreclosure",
    h1: "Behind on Payments? Stop Foreclosure Before It Wrecks Your Credit",
    subh: "If you've received a Notice of Default or a foreclosure auction date, we can help. Fast cash offers that pay off the bank and protect your credit.",
    bullets: [
      "We typically close within 30 days, often sooner — flexible timeline depending on your situation",
      "Pay off your mortgage in full and walk away clean",
      "No judgement, no lectures — just a real solution",
    ],
    faq: [
      { q: "How late is too late?", a: "As long as the sale hasn't happened, we can usually help. Even the week of the auction, call us — we've stopped sales with 48 hours to spare." },
      { q: "Will this hurt my credit more?", a: "No — selling before the foreclosure completes protects your credit far better than letting the bank take it." },
    ],
  },
  "sell-inherited-house": {
    slug: "sell-inherited-house",
    situation: "Inherited",
    h1: "Sold Overnight: Turn an Inherited House Into Cash",
    subh: "You didn't ask for this house. You don't want to fix it, clean it, or drive across the country to sell it. We take it off your hands.",
    bullets: [
      "We buy out-of-state inherited homes remotely",
      "No cleanout, no repairs, no showings",
      "Split the proceeds with siblings on your schedule",
    ],
    faq: [
      { q: "There are multiple heirs — is that a problem?", a: "Not at all. We work with all heirs and can coordinate the paperwork so everyone gets paid at closing." },
    ],
  },
  "sell-house-tax-lien": {
    slug: "sell-house-tax-lien",
    situation: "Tax Delinquent",
    h1: "Owe Back Property Taxes? Sell for Cash Before the County Takes It",
    subh: "Tax liens and delinquent taxes don't have to end in tax sale. We pay off the county at closing and put cash in your pocket.",
    bullets: [
      "We settle liens directly at the closing table",
      "Works even if you owe more than the house is worth (in many cases)",
      "Discreet, fast, no lender approval needed",
    ],
    faq: [
      { q: "The county says my auction is next month.", a: "Call us today. We routinely close before tax sale dates and stop the lien in its tracks." },
    ],
  },
  "sell-house-as-is": {
    slug: "sell-house-as-is",
    situation: "Damaged",
    h1: "Fire, Flood, Foundation, Hoarder — We Buy Houses As-Is",
    subh: "The worse the condition, the more you should call us. Fixer-uppers and disaster homes are exactly what we're looking for.",
    bullets: [
      "No repairs. No cleaning. No inspections you have to pay for.",
      "Cash offer within 24 hours, flexible closing (~30 days, often sooner)",
      "We handle permits, code violations, and unpermitted work",
    ],
    faq: [
      { q: "The house isn't even livable.", a: "Perfect. We buy homes that no traditional buyer would touch — fire damage, mold, structural, everything." },
    ],
  },
};

export const SITUATION_OPTIONS = [
  "Probate",
  "Pre-Foreclosure",
  "Tax Delinquent",
  "Inherited",
  "Vacant",
  "Damaged / Needs Repair",
  "Behind on Payments",
  "Divorce",
  "Relocation",
  "Tired Landlord",
  "Other",
];

export const CONDITION_OPTIONS = [
  "Move-in ready",
  "Minor cosmetic work needed",
  "Major repairs needed",
  "Uninhabitable / heavy damage",
];

export const TIMELINE_OPTIONS = [
  "ASAP — within 7 days",
  "Within 30 days",
  "1 – 3 months",
  "Just exploring",
];

export const REASON_OPTIONS = [
  "Fast Move",
  "Financial Reasons",
  "Condition of Home",
  "Inherited Property",
  "Other",
];
